import { LOADING_DATE_PICKER_RECEIVE, LOADING_DATE_PICKER_TOGGLE } from '../Actions/LoadingDatePicker.action';

const DEFAULT_STATE = {
    showPicker: false,
    loadingDateObject: {},
};

export const loadingDatePicker = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
    case LOADING_DATE_PICKER_RECEIVE:
        case LOADING_DATE_PICKER_TOGGLE:
        return {
            ...state,
            ...action.payload,
        };
    default:
        return state;
    }
}